// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {FormControl, Validators} from "@angular/forms";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_CreateByNameDialogInput extends MatDialogDataBaseInput {
	title: string;
}

export interface DialogData_CreateByNameDialogOutput extends MatDialogDataBaseOutput {
	newName: string;
}

@Component({
	selector: "sim-create-by-name-dialog",
	templateUrl: "./create-by-name-dialog.component.html",
	standalone: false,
})
export class CreateByNameDialogComponent extends BasicMaterialDialog<
	CreateByNameDialogComponent,
	DialogData_CreateByNameDialogInput,
	DialogData_CreateByNameDialogOutput
> {
	formCtrl = new FormControl<string>("", [Validators.required]);

	constructor(_injector: Injector) {
		super(_injector);
	}

	public createNewItem(): void {
		if (this.formCtrl.invalid) return;

		this.close({
			action: "ok",
			newName: this.formCtrl.value,
		});
	}
}
